<script>
import CustomerRatings4BigScreen from './CustomerRatings4BigScreen/index.vue'
import CustomerRatings4SmallScreen from './CustomerRatings4SmallScreen/index.vue'
export default {
  components: {
    CustomerRatings4BigScreen,
    CustomerRatings4SmallScreen
  },
  props: {
    width: {
      default: 0,
      type: Number
    },
    sum: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      isBigScreen: true
    }
  },
  created() {
    if (this.$_thebox.clientWidth > 940) {
      this.isBigScreen = true
    } else {
      this.isBigScreen = false
    }
  }
}
</script>
<template>
  <div>
    <CustomerRatings4BigScreen v-show="isBigScreen" :sum="sum" :width="width" />
    <CustomerRatings4SmallScreen
      v-show="!isBigScreen"
      :sum="sum"
      :width="width"
    />
  </div>
</template>
